import { Component, OnInit } from '@angular/core';
import { ISpecificBrickSettingsComponent } from '../../../../dashboard/brick-settings/brick-specific-type-settings/ISpecificBrickSettingsComponent';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { CallControlSettingsState } from '../../../../../store/dashboard/brick-wall/brick-settings/specific-brick-settings/call-control-settings/call-control-settings.state';
import { ChangeShowDialpad } from '../../../../../store/dashboard/brick-wall/brick-settings/specific-brick-settings/call-control-settings/call-control-settings.actions';
import { map } from 'rxjs/operators';

@Component({
   selector: 'samweb-call-control-settings',
   templateUrl: './call-control-settings.component.html',
   styleUrls: ['./call-control-settings.component.scss'],
})
export class CallControlSettingsComponent implements OnInit, ISpecificBrickSettingsComponent {
   public brickInstanceId: string;

   public showDialpadSetting$: Observable<boolean>;

   constructor(private store: Store) {}

   ngOnInit() {
      this.showDialpadSetting$ = this.store.select(CallControlSettingsState.getIsDialpadShown).pipe(map((fn) => fn(this.brickInstanceId)));
   }

   changeShowDialpad(showDialpad: boolean) {
      this.store.dispatch(new ChangeShowDialpad(this.brickInstanceId, showDialpad));
   }
}
